import { exportFormattedTableExcel } from './formattedExcelExport';

export async function exportAsCSV(columns, records, filename = 'export', options = {}) {
  await exportFormattedTableExcel(columns, records, filename, options);
}
